<template>
  <v-app>
    <!--<v-toolbar app>
      <v-toolbar-title class="headline">
        Royal Rangers 33 Braunschweig
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">*|^^^^^^^^^|-</span>
      </v-btn>
    </v-toolbar>-->
    
    <v-navigation-drawer v-model="drawer" :clipped="scrolled" :mini-variant="mini" stateless width="200" fixed app>
      <v-list dense>
      
          <v-list-tile @click="$router.push(item.path)" v-for="(item,index) of this.$router.options.routes" v-show="item.inmenu" :key="item.name" :exact="item.path=='/'">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="std" :dark="!scrolled" v-bind:class="scrolled?'':'scrolltop'" fixed app>
      <v-toolbar-side-icon @click.stop="($vuetify.breakpoint.mdAndUp&&scrolled)?mini=!mini:drawer=!drawer"></v-toolbar-side-icon>
      <v-toolbar-title><span v-if="$vuetify.breakpoint.smAndUp">Royal Rangers 33 Braunschweig</span><span v-else>RR33</span></v-toolbar-title>
    </v-toolbar>
    
    
    <v-content class="fixos">
      <div fluid>
        <router-view/>
      </div>
    </v-content>
    <Footer/><!--v-footer would break a lot-->
  </v-app>
</template>

<script>
import Footer from './components/partials/Footer'

export default {
  name: 'App',
  components: {
    Footer
  },
  data() {
    return{
      drawer: false,
      scrolled: false,
      mini: false
    }
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > window.innerHeight/2;//0; //window.pageYOffset
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    scrolled: function (val) {
      if(this.$vuetify.breakpoint.mdAndUp){
        if(val){
          if(!this.drawer){
            this.drawer = true;
            this.mini = true;
          }
        }else{
          this.drawer = !this.mini; //wenn nicht mini, dann bleibt offen
          this.mini = false;
        }
      }
    }
  }
}
</script>

<style>
.v-content.fixos{
padding-top:0px !important; /*fixes overscroll by titlebar height*/
}

.std * {
  transition: none;
}

.scrolltop{
  background-color: transparent!important;
  box-shadow: none;
  -webkit-box-shadow: none;
}

/*Mark exernal urls*/
a[target=_blank]::after {
  font-family: 'Material Icons';
  content: '\E89E';
}

a[target=_blank].imginside::after {
  content: '';
}
</style>

<!--
Was auf die Seite soll:

Wer wir sind
Termine (Stammtreffs) mit Karte
Aktionen (Volleyballturnier)
Teams
Grundsätze (Motto,Zacken)
Kontakt (stammleitung email adresse, name, karte)
Impressum & Zeug

Link zum CZB
Link zu RR
Link zum RR Shop


-->
